"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = void 0;
const axios_1 = __importDefault(require("axios"));
class Provider {
    constructor(obj) {
        this.id = obj.provider_id || -1;
        this.name = obj.name || '-';
        this.logo = obj.logo || '-';
        this.linked = obj.linked || false;
        this.disabled = obj.disabled || false;
    }
    async authProvider() {
        try {
            const formData = {
                provider: this.name
            };
            const call = await axios_1.default.post('/integrations/leaf/auth', formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const respURL = call.data.url;
            window.open(respURL, '_blank');
        }
        catch (error) {
            console.error(error);
        }
    }
}
exports.Provider = Provider;
